<template>
  <div class="in-dm-media">
    <video
      v-if="isVideo && !isVideoError"
      ref="videoRef"
      class="in-dm-media__video"
      :src="url"
      muted
      autoplay
      playsinline
      @error="onVideoError"
    />
    <InDmImage v-else :url="url" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import InDmImage from '@/client/components/_atoms/in_dm_image'
import { useErrorState } from '@/client/components/_hooks/useErrorState'

interface Props {
  url: string
  mediaType: 'image' | 'video'
}
const props = defineProps<Props>()

const { hasError: isVideoError, onError: onVideoError } = useErrorState()
const isVideo = computed(() => props.mediaType === 'video')
const videoRef = ref<HTMLVideoElement | null>(null)

onMounted(() => {
  if (videoRef.value) {
    videoRef.value.muted = true
  }
})
</script>

<style lang="scss" scoped>
.in-dm-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 180px;
  overflow: hidden;
  border-radius: 16px;
}

.in-dm-media__video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
